import { divRound } from './money.js';
/**
 * Invoices in another currency. Amounts stay in that currency on the invoice; VAT and the reports need
 * euros, at the Lietuvos bankas rate (units of the currency for 1 EUR, as LB publishes it).
 */
/** Currencies with a daily Lietuvos bankas (ECB) rate and two decimals. */
export const CURRENCIES = ['EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'NOK', 'DKK', 'CZK', 'HUF', 'RON', 'TRY', 'CAD', 'AUD', 'CNY'];
/** "1.0850" → 1085000 (millionths); null when it is not a positive rate with up to 6 decimals. */
export function parseRate6(rate) {
    const m = /^(\d{1,9})(?:[.,](\d{1,6}))?$/.exec(rate.trim());
    if (!m)
        return null;
    const micro = BigInt(m[1]) * 1000000n + BigInt((m[2] ?? '').padEnd(6, '0'));
    return micro > 0n ? micro : null;
}
/** An amount in the invoice currency in euro cents, rounded half away from zero. */
export function toEur(amount, rate) {
    const micro = parseRate6(rate);
    if (micro === null)
        throw new Error(`invalid rate ${rate}`);
    return Number(divRound(BigInt(amount) * 1000000n, micro));
}
/** Six decimals at most, no trailing zeros: 1.085 → "1.085". */
export function normaliseRate(rate) {
    const micro = parseRate6(rate);
    if (micro === null)
        throw new Error(`invalid rate ${rate}`);
    const whole = micro / 1000000n;
    const frac = (micro % 1000000n).toString().padStart(6, '0').replace(/0+$/, '');
    return frac ? `${whole}.${frac}` : whole.toString();
}
//# sourceMappingURL=fx.js.map